class RipsApi {
    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unhautorized!`);
            default:
                console.log("Success Response");
                break;
        }
    }

    //Generar todos los Archivos
    async generarArchivosPlanosRIPS(params) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}rips/generar-archivos-planos`;
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'responseType': 'arraybuffer',
            },
            body: JSON.stringify(params)
        }).then(response => {
            if (response.status === 200) {
                return response.blob();
            }
            else {
                throw new Error('Ocurrio un error con el comprimido')
            }
        }
        ).then(blob => {
            datos = blob;
        })
            .catch((error) => {
                datos = null;
            });
        return datos;
    }

    async consultarUltimoConsecutivo() {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}rips/consultar-ultimo-consecutivo?id_clinica=${sessionStorage.getItem('id_clinica')}`;
        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async listarFacturasParaRips(dataSend) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}rips/listar-facturas-para-rips`;
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async listarRegistroRips(id_tercero) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}rips/listar?id_tercero=${id_tercero}`;
        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async descargarRIPSRegistrados(id_rip) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}rips/descargar-rip/${id_rip}`;
        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            this.checkStatus(response);
            if (response.status != 500 && response.status != 403 && response.status != 404) {
                return response.blob();
            }
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    //Lista los terceros con el contrato
    loadThirdPlusContract = async () => {
        let datos;
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/listar-terceros', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error(response.json());
            }
        }).then(data => {
            console.log("ThirdPlusContract", data);
            datos = data;
        }).catch((error) => {
            datos = [];
            console.error('Error:', error);
        });
        return datos;
    }

    //Lista las facturas del tercero según el contrato
    loadThirdPartyInvoicesWithContract = async (dataSend) => {
        let datos;
        /* let fechaInicial = moment(startDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        let dataSend = {
            id_contrato: idContract,
            id_tercero: idThird,
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss')
        } */
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'contratos/verificar-facturas', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error(response.json());
            }
        }).then(data => {
            console.log("InvoicesContracts", data);
            datos = data;
        }).catch((error) => {
            console.error('Error:', error);
            datos = null;
        });
        return datos;
    }

     //Generar todos los Archivos
     async generarArchivosPlanosRIPSEspecificos(params) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}rips/generar-archivos-planos-especificos`;
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'responseType': 'arraybuffer',
            },
            body: JSON.stringify(params)
        }).then(response => {
            if (response.status === 200) {
                return response.blob();
            }
            else {
                throw new Error('Ocurrio un error con el comprimido')
            }
        }
        ).then(blob => {
            datos = blob;
        })
            .catch((error) => {
                datos = null;
            });
        return datos;
    }

}

export default new RipsApi();